var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "detail"
  }, [_vm.loading ? [_c('Loader', {
    attrs: {
      "content-id": _vm.address,
      "message": 'Fetching Address Details'
    }
  })] : [!_vm.address ? _c('HTTPError', {
    attrs: {
      "id": '',
      "title": 'Address Details Not Found',
      "message": 'A record for this address ID was not found in the DComm Explorer',
      "support-u-r-l": "/comingsoon"
    }
  }) : [_c('EVMAddressSummary', {
    attrs: {
      "address": _vm.address
    }
  }), !_vm.hasSubnet ? _c('EVMTransactions', {
    attrs: {
      "txs": _vm.filteredTransactions,
      "limits": _vm.transactionsOffsets
    },
    on: {
      "update": _vm.updateOffset,
      "next": _vm.nextPage,
      "back": _vm.previousPage
    }
  }) : _vm._e()]]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }